module.exports = __webpack_public_path__ + "img/Blumenwiese-1920@2x.00ba7997.jpg";